import { Box, Table, Thead, Tbody, Th, Tr, Td, Flex, IconButton } from "@chakra-ui/react";
import {
  SortOrder,
  useNewsesQuery,
  useDeleteNewsMutation,
} from "../../generated/graphql";
import {
  FcRefresh,
  FcDatabase,
  FcPlus,
  FcEditImage,
  FcApproval,
  FcCancel,
} from "react-icons/fc";
import DeleteItem from "../../components/delete/DeleteItem";
import Loading from "../../components/loading/Loading";
import Error from "../../components/error/Error";
import PageLayout from "../../components/ui/PageLayout";
import { Link } from "react-router-dom";
import Description from "../../components/description/Description";

const All = () => {
  const [deleteNews] = useDeleteNewsMutation();

  const { loading, error, data, refetch } = useNewsesQuery({
    variables: {
      orderBy: {
        order: SortOrder.asc,
      },
    },
    fetchPolicy: "network-only",
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error error={error} />;
  }

  const handleDelete = async (id: string) => {
    try {
      await deleteNews({
        variables: {
          where: {
            id,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <PageLayout>
      <Flex
        mb={6}
        justifyContent={"space-between"}
        alignItems="center"
        bgColor={"gray.100"}
        padding={2}
        rounded="md"
      >
        <Box fontSize={"18px"} fontWeight="bold">
          News List
        </Box>
        <Flex experimental_spaceX={4}>
          <IconButton
            icon={<FcRefresh />}
            aria-label="Refetch Query"
            onClick={() => refetch()}
          />
          <IconButton
            to={`/news/create`}
            as={Link}
            icon={<FcPlus />}
            aria-label="Add Item"
            onClick={() => refetch()}
          />
        </Flex>
      </Flex>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Descriptions</Th>
            <Th textAlign={"center"}>Contents</Th>

            <Th>Status</Th>
            <Th textAlign={"center"}>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.findManyNews.map((news, i) => {
            return (
              <Tr key={i}>
                <Td>{i + 1}</Td>
                <Td minWidth={"300px"}>
                  <Description
                    field="news"
                    id={news.id}
                    descriptions={news.descriptions}
                    refetch={refetch}
                  />
                </Td>
                <Td textAlign={"center"}>
                  <IconButton
                    aria-label="Change Status"
                    as={Link}
                    to={`/content/news/${news.id}`}
                    icon={<FcDatabase />}
                  />
                </Td>

                <Td>
                  {news.status ? (
                    <IconButton aria-label="Change Status" icon={<FcApproval />} />
                  ) : (
                    <IconButton aria-label="Change Status" icon={<FcCancel />} />
                  )}
                </Td>

                <Td>
                  <Flex justifyContent={"center"}>
                    <Box mx={2}>
                      <IconButton
                        aria-label="Edit"
                        icon={<FcEditImage />}
                        as={Link}
                        to={`/news/update/${news.id}`}
                      />
                    </Box>
                    <Box mx={2}>
                      <DeleteItem
                        id={news.id}
                        refetch={refetch}
                        title={`${news.descriptions[0].title}`}
                        handleDelete={handleDelete}
                      />
                    </Box>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </PageLayout>
  );
};

export default All;
